module.exports = __webpack_public_path__ + "img/concord-img_large.78bd6ffb.jpeg";